import React from 'react';

const FilterIcon = (): JSX.Element => (
  <svg
    fill="none"
    height="16"
    viewBox="0 0 16 16"
    width="16"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M14.6039 1.77734H1.45751C1.02001 1.77734 0.7468 2.25413 0.966443 2.63449L5.12001 9.87377V13.9916C5.12001 14.3077 5.37359 14.5631 5.68787 14.5631H10.3736C10.6879 14.5631 10.9414 14.3077 10.9414 13.9916V9.87377L15.0968 2.63449C15.3147 2.25413 15.0414 1.77734 14.6039 1.77734ZM9.66287 13.2773H6.39859V10.6345H9.66466V13.2773H9.66287ZM9.8343 9.23092L9.6843 9.49163H6.37537L6.22537 9.23092L4.8593 6.84877H11.2022L9.8343 9.23092ZM11.8575 5.70592H4.20394L2.68609 3.06306H13.3754L11.8575 5.70592Z"
      fill="#4F4F4F"
    />
  </svg>
);

export default FilterIcon;
